interface ICreateParishData {
    name: string;
    cityName: string;
}

export const NewCreateParishData: ICreateParishData = { name: "", cityName: "" };

export default ICreateParishData;
